import I18n from 'I18n';
import { useSelector } from 'react-redux';
// @ts-expect-error Untyped import
import { useSelectedRows } from '../../redux/selectedRows';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
// @ts-expect-error Untyped import
import ReportBulkActions from '../bulkActions/ReportBulkActions';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/transitional/components/View';
// @ts-expect-error Untyped import
import { selectFilteredReportCount } from '../../selectors/reportsSelector';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { AccordionTransition } from 'foundations-components/transitional/components/AccordionTransition';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BulkActionsContainer = ({
  actionableRows
}) => {
  const {
    selectedRows,
    selectedAll,
    selectAllDisabled,
    deselectAll,
    selectedEverything
  } = useSelectedRows({
    actionableRows
  });
  const filteredReportCount = useSelector(selectFilteredReportCount);
  const selectedCount = !selectedEverything ? selectedRows.size : filteredReportCount;
  return /*#__PURE__*/_jsx(AccordionTransition, {
    open: selectedRows.size > 0,
    children: /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(ReportBulkActions, {
        actionableRows: actionableRows,
        children: /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          gap: "400",
          children: /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            gap: "200",
            children: [/*#__PURE__*/_jsx(Checkbox, {
              size: "small",
              "aria-label": I18n.text('reports.table.header.checkbox'),
              indeterminate: !selectedRows.isEmpty() && !selectedAll,
              checked: selectedAll,
              disabled: selectAllDisabled,
              "data-test-id": "report-bulk-actions-select-all",
              onChange: deselectAll,
              inline: true
            }), /*#__PURE__*/_jsx(Text, {
              as: "small",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: 'reports.table.header.selected',
                options: {
                  selectedCount
                }
              })
            })]
          })
        })
      })
    })
  });
};